import { render, staticRenderFns } from "./gradeDetail.vue?vue&type=template&id=60cdc305&scoped=true"
import script from "./gradeDetail.vue?vue&type=script&lang=js"
export * from "./gradeDetail.vue?vue&type=script&lang=js"
import style0 from "./gradeDetail.vue?vue&type=style&index=0&id=60cdc305&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cdc305",
  null
  
)

export default component.exports